import { ListItemIcon, ListItemText, MenuItem } from "@material-ui/core";
import { isBoolean } from "lodash";
import { ApiClientListWithRedirectionDto } from "../../../common/data/service-proxies";
import { useHistory } from "react-router-dom";
import resourceNames from "../../../common/data/resourceNames";
import { useTranslate } from "react-admin";
interface Props {
  label: string;
  icon: JSX.Element;
  record?: ApiClientListWithRedirectionDto;
  resource?: string;
  onClick?: (event: React.MouseEvent) => void;
  hidden?: boolean | ((record: ApiClientListWithRedirectionDto) => boolean);
}

export const ViewRedirectedApiClientMenuItem = ({
  record,
  hidden,
  label,
  icon,
  onClick,
  ...rest
}: Props) => {
  const history = useHistory();
  const translate = useTranslate();
  if (!record?.id) {
    return null;
  }

  if (isBoolean(hidden)) {
    if (hidden) {
      return null;
    }
  } else {
    if (hidden && hidden(record)) {
      return null;
    }
  }

  return (
    <MenuItem
      {...rest}
      className="actions-menu-item"
      onClick={(e) => {
        history.push(
          `/${resourceNames.ADMIN_API_CLIENTS}/view/${record.id}?redirectionId=${record.redirectionRequestId}`
        );
        if (typeof onClick === "function") {
          onClick(e);
        }
      }}
    >
      <ListItemIcon>{icon}</ListItemIcon>
      <ListItemText>{translate(label, { _: label })}</ListItemText>
    </MenuItem>
  );
};
